import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-facebook-24-px_38373f2e636f0137dce7a5eefb729d1b",
  "use": "ic-facebook-24-px_38373f2e636f0137dce7a5eefb729d1b-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"ic-facebook-24-px_38373f2e636f0137dce7a5eefb729d1b\">\n    <path fill=\"#55586B\" fill-rule=\"evenodd\" d=\"M15.6 5.32h1.9V2.14A26.666 26.666 0 0 0 14.731 2c-2.749 0-4.629 1.66-4.629 4.7v2.62H7v3.56h3.102V22h3.72v-9.12h3.092l.465-3.56H13.82V7.05c0-1.05.283-1.73 1.78-1.73z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol